import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FaixaCarteiraPessoaJuridica } from 'src/app/model/faixa-carteira-pessoa-juridica.model';
import Utils from 'src/app/shared/fgi-utils';

@Component({
    selector: 'app-faixa-carteira-pessoa-juridica-listagem',
    templateUrl: './faixa-carteira-pessoa-juridica-listagem.component.html',
    standalone: false
})
export class FaixaCarteiraPessoaJuridicaListagemComponent implements OnInit {

  @Input() public faixasCarteira: FaixaCarteiraPessoaJuridica[];
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  private atributosOrdenacao: EntityOrderedRequestParameters;
  @Output() public exportarFaixas: EventEmitter<any> = new EventEmitter<any>();

  public opcoesPaginacao: number[];



  constructor() {

  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];
  }
  

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
      this.faixasCarteira = this.faixasCarteira.sort((a, b) => {
        if (ord.sentido == "asc") {
            return Utils.compara(a, b, ord.atributo);
        }
        else {
            return -1 * Utils.compara(a, b, ord.atributo);
        }
        });
  }

  btnExportarFaixas() {
    this.exportarFaixas.emit(null);
  }

  formatarPontoVirgula(valor: string) {
    return valor?.replace(/\./g, ',');
  }

}